document.addEventListener('DOMContentLoaded', function() {
    // Check if the current URL matches the specific page
    if (window.location.href.includes('/products/wildcard-secret-wallet?discount=followtherabbit')) {

        // Create and show the popup
        var popup = document.createElement('div');
        popup.id = 'popup-message';
        popup.innerHTML = `
            <div style="background: rgba(0,0,0,0.5); color: white; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100vw; height: auto; z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 0; margin: 0;">
                <button id="play-sound-button" style="background: transparent; border: none; display: flex; align-items: center; justify-content: center; padding: 0; margin: 0;">
                    <img src="https://cdn.shopify.com/s/files/1/0569/4731/0647/files/cilli_promo.png?v=1733755336" style="max-height: 70vh; max-width: 90vw; height: auto; width: auto;">
                </button>
            </div>`;
        document.body.appendChild(popup);

        // Create the audio element and try to autoplay
        var sound = new Audio('https://cdn.shopify.com/s/files/1/0569/4731/0647/files/lozsecret.mp3?v=1727961551');
        var hasPlayed = false;

        // Function to play sound only once
        function playSound() {
            if (!hasPlayed) {
                sound.play().then(() => {
                    hasPlayed = true;
                }).catch((error) => {
                    document.getElementById('play-sound-button').style.display = 'block';
                });
            }
        }

        // Try to autoplay on page load
        playSound();

        // Add click event listener for manual play if needed
        document.getElementById('play-sound-button').addEventListener('click', function() {
            playSound();
            setTimeout(function() {
            document.getElementById('popup-message').remove();
        }, 2000);
        });

        // Optional: Close popup after a few seconds
        setTimeout(function() {
            document.getElementById('popup-message').remove();
        }, 5000); // Popup disappears after 5 seconds
    }
});